import * as saleForecast from './saleForecast';

const reducers = {
  ...saleForecast,
};

export default reducers;
